import { RightSide } from "./right";
export default RightSide;
